import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CompanyStrategy } from './company-strategy.model';

export class PasswordValidator {
  static validPassword(limitations: CompanyStrategy, oldPasswordCtrl?: FormControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (oldPasswordCtrl && control.value === oldPasswordCtrl.value) {
        return { 'current-password': true };
      }
      if (limitations && control.value) {
        const password: string = control.value;
        const {
          password_nmin_characters,
          password_nmin_special_characters,
          password_has_uppercase,
          password_has_number,
          password_has_lowercase,
        } = limitations;
        if (password_nmin_characters && verifyNMinCharacters(password, password_nmin_characters)) {
          return { 'too-short': true };
        }
        if (
          password_nmin_special_characters &&
          verifyNMinSpecialCharacters(password, password_nmin_special_characters)
        ) {
          return { 'missing-special-char': true };
        }

        if (password_has_uppercase || password_has_number || password_has_lowercase) {
          const errors = {};
          let hasError = false;
          if (password_has_uppercase && !/[A-Z]+/g.test(password)) {
            errors['at-least-one-big-cap-in-password'] = true;
            hasError = true;
          }
          if (password_has_number && !/[0-9]+/g.test(password)) {
            errors['at-least-one-number-in-password'] = true;
            hasError = true;
          }
          if (password_has_lowercase && !/[a-z]+/g.test(password)) {
            errors['at-least-one-small-cap-in-password'] = true;
            hasError = true;
          }

          return hasError ? errors : null;
        }
      }
      return null;
    };
  }

  static validConfirmPassword(passwordCtrl: FormControl): ValidatorFn {
    return (confirmPasswordCtrl: FormControl): ValidationErrors | null => {
      const password = passwordCtrl?.value;
      if (passwordCtrl?.valid && password !== confirmPasswordCtrl?.value) {
        return { 'do-not-match': true };
      }
      return null;
    };
  }
}

function verifyNMinCharacters(password: string, password_nmin_characters: number): boolean {
  return !password ? true : password.length < password_nmin_characters;
}

function verifyNMinSpecialCharacters(password: string, password_nmin_special_characters: number): boolean {
  let hasSpecialChars = true;
  if (password_nmin_special_characters > 0) {
    hasSpecialChars = password.match(/[^a-z0-9]/gi)?.length >= password_nmin_special_characters;
  }
  return !hasSpecialChars;
}
